import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Pagination, Autoplay, Navigation } from 'swiper'
// import 'swiper/css/swiper.css'
// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'
SwiperCore.use([Pagination, Autoplay, Navigation])

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOptions: {
        breakpoints: {
          320: {
            slidesPerView: 1.7,
            spaceBetween: 15
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4.5,
            spaceBetween: 15
          }
          // when window width is >= 640px

        }
      }
    }
  },
  mounted () {
    this.logger('from mounted mixins swiper')

    // const mySwiper = new Swiper('.bannerList', {
    //     navigation: {
    //         prevEl: '.sliderPrev-btn',
    //         // nextEl: '.slideNext-btn'
    //     }
    // })
  }
//   directives: {
//     swiper: directive
//   }
}
